import { useState, useEffect } from 'react';

const useResponsive = () => {
  const [screenSize, setScreenSize] = useState({
    width: 1024, // Default to desktop width to prevent hydration issues
    height: 768
  });
  const [isHydrated, setIsHydrated] = useState(false);

  useEffect(() => {
    // Set the actual screen size after hydration
    setScreenSize({
      width: window.innerWidth,
      height: window.innerHeight
    });
    setIsHydrated(true);

    const handleResize = () => {
      setScreenSize({
        width: window.innerWidth,
        height: window.innerHeight
      });
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return {
    isMobile: isHydrated ? screenSize.width < 768 : false, // Conservative defaults
    isTablet: isHydrated ? screenSize.width >= 768 && screenSize.width < 1024 : false,
    isDesktop: isHydrated ? screenSize.width >= 1024 : true, // Default to desktop
    width: screenSize.width,
    height: screenSize.height,
    isHydrated
  };
};

const MobileOptimizedComponent = ({ children, mobileComponent, tabletComponent }) => {
  const { isMobile, isTablet } = useResponsive();

  if (isMobile && mobileComponent) {
    return mobileComponent;
  }
  
  if (isTablet && tabletComponent) {
    return tabletComponent;
  }

  return children;
};

export { useResponsive, MobileOptimizedComponent };
